"use strict";
/**
 *
 * @param contentInMultipleLanguages string with qtranslate content
 * @returns {lang:"en", text:"only the english part"} : QTranslateLanguage[]
 *
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var qExtractor = function qExtractor(contentInMultipleLanguages) {
  var reg1 = /\[:[\S]*\]/gm;
  var reg2 = /\[:[\S]*\]/gm;
  var content = contentInMultipleLanguages.split(reg1).filter(function (t) {
    return '' !== t;
  });
  var langs = contentInMultipleLanguages.match(reg2);
  langs = langs && langs.slice(0, -1).map(function (l) {
    return l.replace(/\[|:|\]/g, '');
  }); //   console.log({ langs, content })

  if (langs && langs.length === content.length) {
    var result_1 = [];
    langs.forEach(function (lang, i) {
      //   console.log(lang)
      result_1.push({
        lang: lang,
        text: content[i]
      });
    });
    return result_1;
  } else {
    return [];
  }
};

exports.default = qExtractor;